"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
var _overlay = require("@cbhq/cds-common/animation/overlay");
var _layout = require("../../layout");
var _useMotionProps = require("../../motion/useMotionProps");
var _useThemeProviderStyles = require("../../system/useThemeProviderStyles");
const _excluded = ["onPress", "animated"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const OverlayContent = /*#__PURE__*/(0, _react.forwardRef)((_ref, forwardedRef) => {
  let onPress = _ref.onPress,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? false : _ref$animated,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _useThemeProviderStyl = (0, _useThemeProviderStyles.useThemeProviderStyles)(),
    style = _useThemeProviderStyl.style;
  const motionProps = (0, _useMotionProps.useMotionProps)({
    style,
    enterConfigs: [_overlay.animateInOpacityConfig],
    exitConfigs: [_overlay.animateOutOpacityConfig],
    exit: 'exit'
  });
  const content = /*#__PURE__*/_react.default.createElement(_layout.VStack, _extends({
    background: "backgroundOverlay",
    onClick: onPress,
    pin: "all"
  }, props, {
    ref: forwardedRef
  }));

  // override background overlay color for dark mode
  return animated ? /*#__PURE__*/_react.default.createElement(_framerMotion.m.div, _extends({}, motionProps, {
    "data-testid": `${props.testID}-motion`
  }), content) : /*#__PURE__*/_react.default.createElement("div", {
    style: style
  }, content);
});
exports.OverlayContent = OverlayContent;